(function ($, Drupal) {

  Drupal.behaviors.beforeAfterFeatured = {
    attach(context) {

      if (!context || context !== document) {
        return;
      }

      $(document)
      .off('click.beforeAfterFeatured')
      .on(
          'click.beforeAfterFeatured',
          '.view-before-after-content .view-content > .views-row',
          function () {

            const row = this;

            const paragraph = row.closest('.paragraph--type--before-after-content');

            if (!paragraph) {
              return;
            }

            const featured = paragraph.querySelector('.before-after-featured-content');

            if (!featured) {
              return;
            }

            $(paragraph)
            .find('.view-before-after-content .views-row')
            .removeClass('active');

            $(row).addClass('active');

            const selectedNode = row.querySelector(
                '.views-field-rendered-entity .node--type-before-after'
            );

            if (!selectedNode) {
              return;
            }

            const clone = selectedNode.cloneNode(true);

            // Reset Drupal once().
            clone.querySelectorAll('[data-once]').forEach(function (el) {
              el.removeAttribute('data-once');
            });

            // Reset Splide.
            clone.querySelectorAll('.splide').forEach(function (slider) {

              slider.classList.remove(
                  'is-initialized',
                  'is-overflow',
                  'is-active'
              );

              slider.removeAttribute('data-splide');

            });

            featured.replaceChildren(clone);

            Drupal.attachBehaviors(featured);

          }
      );

    }
  };

})(jQuery, Drupal);